import { forwardRef, useState } from "react";
import useFormFieldAccess from "../../../hooks/useFormFieldAccess";
import ValidationErrors from "../ValidationErrors/ValidationErrors";
import classes from "./SimpleInput.module.css";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import toEnglishNumbers from "../../../utils/textUtils/toEnglishNumbers";
import {
  pStringDecoder,
  pStringEncoder,
  removeEncodeDecodeParts,
} from "../../../utils/textUtils/pEncodeDecode";

const SimpleInput = forwardRef(
  (
    {
      variant = "bottomBorder",
      validityName,
      disabled,
      value,
      onChange,
      onBlur,
      label,
      showPasswordIcon,
      iName,
      praceSpace,
      type,
      maxLength,
      uniqueLabelId,
      onKeyDown,
      pattern,
      ltrInput,
      fieldAccesses,
      fieldNames = [],
      helperTxt,
      isMandatory,
      currentState = "unset",
      disableStateCanEditThisField,
      labelIcon,
      valueStyleType,
      forcePe,
      fieldAddress,
      onFocus,
      encodeDecodeStrAllowed = false,
    },
    ref,
  ) => {
    const [isFocused, setIsFocused] = useState(false);
    const disableForAccess = useFormFieldAccess(
      fieldAccesses,
      fieldNames,
      currentState,
      disableStateCanEditThisField,
    );
    const [showPassword, setShowPassword] = useState(false);
    const keyDownHandler = (e) => {
      if (onKeyDown) {
        onKeyDown(e);
      }
    };
    const formatMoneyWithCommas = (value) => {
      return new Intl.NumberFormat().format(value);
    };
    const formatMoney = (value) => {
      const numericValue = value.replace(/[^0-9]/g, "") === "" ? null : value.replace(/[^0-9]/g, "");
      return numericValue;
    };
    const onChangeHandler = (e) => {
      const inputValue = toEnglishNumbers(e.target.value);
      if (type === "number") {
        if (/^[0-9]+$/.test(inputValue) || inputValue === "") {
          const properObj = {
            target: {
              name: e.target.name,
              value: inputValue === "" ? null : inputValue,
            },
          };
          onChange(properObj, fieldAddress);
        }
      } else if (type === "withSeparator") {
        const formattedValue = formatMoney(inputValue);
        const properObj = { target: { name: e.target.name, value: formattedValue } };
        onChange(properObj, fieldAddress);
      } else if (type === "textOnly") {
        let value = inputValue || null;
        if (value) {
          value = value.replace(/[0-9]/g, "");
          if (encodeDecodeStrAllowed) {
            value = pStringEncoder(value);
          } else {
            value = removeEncodeDecodeParts(value);
          }
        }
        const properObj = {
          target: {
            name: e.target.name,
            value,
          },
        };
        onChange(properObj, fieldAddress);
      } else {
        let value = inputValue || null;
        if (value) {
          if (encodeDecodeStrAllowed) {
            value = pStringEncoder(value);
          } else {
            value = removeEncodeDecodeParts(value);
          }
        }
        const properObj = {
          target: { name: e.target.name, value },
        };
        onChange(properObj, fieldAddress);
      }
    };
    const focusHandler = (e) => {
      if (onFocus) onFocus(e, fieldAddress);
      setIsFocused(true);
    };

    return (
      <div className={classes.container}>
        {/*   <> <label className={validityName ? (validityName?.isValid ? null : classes.textFalse) : null}> {label} </label> <br /> <input maxLength={maxLength} onWheel={type === "number" ? (e) => e.target.blur() : null} type={type} name={iName} disabled={disabled} className={ validityName ? ["addFormInput", validityName?.isValid ? null : classes.false].join(" ") : "addFormInput" } value={value} onChange={onChange} onBlur={onBlur} /> {validityName ? ( <ValidationErrors validity={validityName.isValid} message={validityName.msg} /> ) : null} </> */}

        <label
          className={[
            "inputPLabel",
            variant === "bottomBorder" ? classes.label : classes.allBorderLabel,
            variant
              ? variant === "bottomBorder"
                ? classes.noMargin
                : classes.marginStart
              : classes.marginStart,
            isFocused ||
            (!isFocused && typeof value === "string" && value?.trim() !== "") ||
            (!isFocused && typeof value === "number" && value !== null)
              ? variant === "bottomBorder"
                ? [classes.labelUp, "pLabelUp"].join(" ")
                : [classes.allBorderLabelUp, "pLabelUp"].join(" ")
              : [classes.labelDown, "pLabelDown"].join(" "),
            disabled || disableForAccess
              ? "disabledinputPLabel"
              : isFocused
                ? variant === "bottomBorder"
                  ? "focusedinputPLabel"
                  : classes.pinkColor
                : validityName
                  ? validityName?.isValid
                    ? "enabledinputPLabel"
                    : "invalidinputPLabel"
                  : "enabledinputPLabel",
          ].join(" ")}
          htmlFor={uniqueLabelId ? uniqueLabelId : iName}
        >
          <span className={classes.iconContainer}> {labelIcon || null}</span>
          <span className={classes.txtLabel}> {label}</span>
          {isMandatory ? <span className={classes.mandatorySign}>*</span> : null}
        </label>
        <input
          autoComplete="off"
          id={uniqueLabelId ? uniqueLabelId : iName}
          onFocus={focusHandler}
          maxLength={maxLength}
          onWheel={type === "number" ? (e) => e.target.blur() : null}
          type={
            type === "decimal" ? "number" : type === "password" && !showPassword ? "password" : "text"
          }
          inputMode={type === "number" ? "numeric" : null}
          // onKeyDown={type === "number" ? checkIfNumber : null}
          name={iName}
          pattern={type === "textOnly" ? "[A-Za-zs]+" : null}
          disabled={disabled || disableForAccess}
          // className={ validityName ? [ classes.addFormInput, validityName?.isValid ? null : classes.false, isFocused ? classes.inputFocused : classes.inputBlured, ].join(" ") : [classes.addFormInput, isFocused ? classes.inputFocused : classes.inputBlured].join(" ") }
          className={[
            "pInput",
            variant === "bottomBorder" ? classes.addFormInput : classes.addFormInputAllBorder,
            ltrInput || type === "number" || type === "withSeparator" ? classes.ltrInput : null,
            disabled || disableForAccess
              ? "disabledPInput"
              : isFocused
                ? variant === "bottomBorder"
                  ? "focusedPInput"
                  : classes.pinkBorder
                : validityName
                  ? validityName?.isValid
                    ? "enabledPInput"
                    : "invalidPInput"
                  : variant === "bottomBorder"
                    ? "enabledPInput"
                    : classes.allBorders,
            ,
            valueStyleType === "largeCentered" ? classes.largeCenteredInput : null,
            forcePe ? classes.forcePe : null,
          ].join(" ")}
          value={
            type === "withSeparator"
              ? value === "" || value === null
                ? ""
                : formatMoneyWithCommas(value)
              : value === null
                ? ""
                : encodeDecodeStrAllowed
                  ? pStringDecoder(value)
                  : value
          }
          onChange={onChangeHandler}
          onKeyDown={keyDownHandler}
          onBlur={(e) => {
            if (onBlur) {
              onBlur(e, fieldAddress);
            }
            setIsFocused(false);
          }}
          ref={ref}
        />
        {showPasswordIcon && value ? (
          <>
            {!showPassword ? (
              <span
                onClick={() => setShowPassword(true)}
                className={variant === "bottomBorder" ? classes.passIcon : classes.allBorderPassIcon}
              >
                <VisibilityOffIcon />
              </span>
            ) : (
              <span
                onClick={() => setShowPassword(false)}
                className={variant === "bottomBorder" ? classes.passIcon : classes.allBorderPassIcon}
              >
                <VisibilityIcon />
              </span>
            )}
          </>
        ) : null}
        {helperTxt ? (
          <span className={["enabledinputPLabel", classes.helperTxtContainer].join(" ")}>
            <span className={classes.helperTxtIcon}>
              <HelpOutlineOutlinedIcon className={classes.questionIcon} />
            </span>
            <span> {helperTxt}</span>
          </span>
        ) : null}
        {validityName ? (
          <ValidationErrors validity={validityName?.isValid} message={validityName?.msg} />
        ) : null}
      </div>
    );
  },
);

export default SimpleInput;
